import Cookies from "js-cookie"
import { Base64 }  from 'js-base64';

export function getToken() {
    const loin_token = Cookies.get('token')
    // console.log(loin_token,'lt')
    if (loin_token) {
        return loin_token
    }
}